import { Navigate } from '@sorare/routing';
import {
  ANY_SPORT_PLAY_BOARDS_ARENA_ARENAMODE,
  ANY_SPORT_PLAY_BOARDS_PRO,
} from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';

import { useLastVisitedBoardView } from '#src/hooks/useLastVisitedBoardView.ts';
import { isArenaMode, modeToArenaMode } from '#src/lib/gameMode.ts';

const BoardsPage = () => {
  const { generateSportContextPath } = useSportContext();
  const { lastVisitedView } = useLastVisitedBoardView();

  const lastMode = lastVisitedView?.lastVisitedMode;

  if (isArenaMode(lastMode)) {
    const arenaMode = modeToArenaMode(lastMode);
    return (
      <Navigate
        to={generateSportContextPath(ANY_SPORT_PLAY_BOARDS_ARENA_ARENAMODE, {
          params: { arenaMode },
        })}
        replace
        keepSearchParams
      />
    );
  }

  return (
    <Navigate
      to={generateSportContextPath(ANY_SPORT_PLAY_BOARDS_PRO)}
      replace
      keepSearchParams
    />
  );
};

export default BoardsPage;
